interface StatusBadgeProps {
  status: string
  variant?: 'default' | 'light'
}

export function StatusBadge({ status, variant = 'default' }: StatusBadgeProps) {
  const getStatusColor = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return variant === 'light' 
          ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
          : 'bg-emerald-500'
      case 'inactive':
        return variant === 'light'
          ? 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300'
          : 'bg-slate-500'
      case 'archived':
        return variant === 'light'
          ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
          : 'bg-amber-500'
      case 'prospect':
        return variant === 'light'
          ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
          : 'bg-blue-500'
      default:
        return variant === 'light'
          ? 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300'
          : 'bg-slate-500'
    }
  }

  return (
    <span 
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(status)}`}
    >
      {status || 'Unknown'}
    </span>
  )
}
